import { ReactNode } from 'react'

interface AlertProps {
  type?: 'error' | 'success' | 'warning' | 'info'
  children: ReactNode
}

export default function Alert({ type = 'error', children }: AlertProps) {
  const styles: Record<string, React.CSSProperties> = {
    error: {
      backgroundColor: '#fee2e2',
      border: '1px solid #ef4444',
      color: '#991b1b',
    },
    success: {
      backgroundColor: '#d1fae5',
      border: '1px solid #10b981',
      color: '#065f46',
    },
    warning: {
      backgroundColor: '#fef3c7',
      border: '1px solid #f59e0b',
      color: '#92400e',
    },
    info: {
      backgroundColor: '#dbeafe',
      border: '1px solid #3b82f6',
      color: '#1e40af',
    }
  }

  return (
    <div style={{
      ...styles[type],
      padding: '0.75rem 1rem',
      borderRadius: '0.5rem',
      marginBottom: '1.5rem',
      fontSize: '0.875rem'
    }}>
      {children}
    </div>
  )
}

